export default "__VITE_ASSET__b421f7f4__"